import { cleanLocallyStoredQuoteFormProvidedInfo } from '~/helpers/quote/locallyStoredQuoteFormValues';
import { cleanLocallyStoredCustomerFormData } from '~/helpers/quote/locallyStoredCustomerFormValues';

// Todo: we can use this method for the ticket - https://linear.app/joinfluffy/issue/INSR-298
export function cleanLocallyStoredAllFormData() {
  cleanLocallyStoredQuoteFormProvidedInfo(); // clean the data from the 1st form
  cleanLocallyStoredCustomerFormData(); // clean the data from the 2nd form
}
